import React from 'react'
import { Grid, Typography, Divider } from '@material-ui/core'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import useStyles from './styles'
import { ModalConfirmacao } from 'components'

export const Confirmacao = (props) => {
  const { openEspelhoConfirmacao, setOpenEspelhoConfirmacao, handleConfirmOperacao, processandoOperacao, formSolicitacao, examesSolicitados } = props
  moment.locale('pt-br', localization)
  const classes = useStyles()

  return (
    <ModalConfirmacao
      aberto={openEspelhoConfirmacao}
      onClose={() => setOpenEspelhoConfirmacao(false)}
      onConfirm={handleConfirmOperacao}
      processando={processandoOperacao}
      titulo="Confirmação dos dados"
      maxWidth="md"
    >
      <Grid item>
        <Typography>
          <b>DADOS BÁSICOS</b>
        </Typography>
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <Divider className={classes.dividerTitle} />
      </Grid>
      <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho} spacing={1}>
        <Grid item md={6} sm={6} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Autoridade Solicitante</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.autReq?.nome?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Outra Autoridade Solicitante</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.autoridadeRequisitanteInput?.toUpperCase() || '-'}</Typography>
        </Grid>
        <Grid item md={4} sm={4} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Setor Solicitante</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.setReq?.nome?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
        <Grid item md={4} sm={4} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Setor Destino do Exame</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.setDest?.nome?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
        <Grid className={classes.item} item md={4} sm={4} xs={12}>
          <Typography variant="body1">
            <b>Data da Solicitação</b>
          </Typography>
          <Typography variant="body1">{moment(formSolicitacao.formState.values.data).format('DD/MM/YYYY')?.toUpperCase()}</Typography>
        </Grid>
      </Grid>

      <Grid item>
        <Typography>
          <b>DADOS DO DOCUMENTO DE SOLICITAÇÃO</b>
        </Typography>
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <Divider className={classes.dividerTitle} />
      </Grid>
      <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho} spacing={1}>
        <Grid item md={6} sm={6} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Tipo de Documento de Solicitação</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.tipoDocumento?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Número do Documento</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.numeroDocumento?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Descrição do Documento</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.descricaoDocumento?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
      </Grid>

      <Grid item>
        <Typography>
          <b>OUTROS DADOS</b>
        </Typography>
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <Divider className={classes.dividerTitle} />
      </Grid>
      <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho} spacing={1}>
        <Grid item md={6} sm={6} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Boletim de Ocorrência</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.boletimOcorrencia?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Indiciado</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.indiciado?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Tipo de Procedimento</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.tipoProc?.nome?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Número de Procedimento</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.numeroProcedimento?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <Typography className={classes.dadoEspelho}>
            <b>Outras Observações</b>
          </Typography>
          <Typography>{formSolicitacao.formState.values.observacoes?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
        </Grid>
      </Grid>

      <Grid item>
        <Typography>
          <b>EXAMES SOLICITADOS</b>
        </Typography>
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <Divider className={classes.dividerTitle} />
      </Grid>
      {examesSolicitados.length
        ? examesSolicitados.map((exame, index) => (
            <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho} spacing={1} key={index}>
              <Grid item md={6} sm={6} xs={12}>
                <Typography className={classes.dadoEspelho}>
                  <b>Exame Solicitado</b>
                </Typography>
                <Typography>{exame.tipoEx?.nome?.toUpperCase() || 'NÃO INFORMADO'}</Typography>
              </Grid>
              <Grid item md={6} sm={6} xs={12}>
                <Typography className={classes.dadoEspelho}>
                  <b>Setor Responsável pelo Exame</b>
                </Typography>
                <Typography>
                  {`${exame.setor?.nome?.toUpperCase() || 'NÃO INFORMADO'} / 
                      ${exame.setor?.divisao?.sigla?.toUpperCase() || 'NÃO INFORMADO'} / 
                      ${exame.setor?.divisao?.regional?.nome?.toUpperCase() || 'NÃO INFORMADO'} /
                      ${exame.setor?.divisao?.regional?.orgao?.sigla?.toUpperCase() || 'NÃO INFORMADO'}`}
                </Typography>
              </Grid>
            </Grid>
          ))
        : null}
    </ModalConfirmacao>
  )
}
